























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Card } from '@/models/Card';
import PlayingCard from '@/components/PlayingCard.vue';

@Component({
  components: {
    PlayingCard
  }
})
export default class PlayingCardPicker extends Vue {
  @Prop({ required: true }) cards!: Card[];
  @Prop() value!: Card | null;

  cardSelected(card: Card) {
    this.emitValue(card === this.value ? null : card);
  }
  upDown() {
    const focusedCard = this.getFocusedCard();
    if (this.value !== focusedCard) this.emitValue(focusedCard);
  }
  downDown() {
    if (this.value) {
      this.focusCardElement(this.value);
      this.emitValue(null);
    }
  }
  leftDown() {
    const isCardSelected = this.value;
    const focusedCard = this.getFocusedCard() || this.value;
    const cardIndex = (focusedCard && this.cards.indexOf(focusedCard)) || -1;
    const previousCardIndex =
      cardIndex <= 0 || cardIndex > this.cards.length ? this.cards.length - 1 : cardIndex - 1;
    const newCard = this.cards[previousCardIndex];
    this.focusCardElement(newCard);
    if (isCardSelected) this.cardSelected(newCard);
  }

  rightDown() {
    const isCardSelected = this.value;
    const focusedCard = this.getFocusedCard() || this.value;
    const cardIndex = (focusedCard && this.cards.indexOf(focusedCard)) || 0;
    const nextCardIndex = cardIndex < 0 || cardIndex >= this.cards.length - 1 ? 0 : cardIndex + 1;
    const newCard = this.cards[nextCardIndex];
    this.focusCardElement(newCard);
    if (isCardSelected) this.cardSelected(newCard);
  }

  onPickerFocus() {
    if (this.value) this.focusCardElement(this.value);
    else this.focusCardElement(this.cards[0]);
  }

  private emitValue = (card: Card | null) => this.$emit('input', card);

  private getFocusedElement = () =>
    this.$children.find(child => child.$el === document.activeElement);
  private getFocusedCard = (): Card | null => this.getFocusedElement()?.$props.card;
  private getElementByCard = (card: Card) =>
    this.$children.find(child => child.$props?.card === card);
  private focusCardElement = (card: Card) =>
    (this.getElementByCard(card)?.$el as HTMLElement | null)?.focus();
}
